<template>
  <article>
    <section>
      <Flex
        :fstyle="{
          justifyContent: 'center',
          padding: isMobile ? '0em 2em' : '0em',
        }"
      >
        <Title>{{ $t('qwello_station.header') }}</Title>
      </Flex>
    </section>
    <Space pheight="112px" />
    <section class="TutorialGrid">
      <div class="PoleImageWrapper">
        <picture>
          <source
            type="image/webp"
            srcset="~@/assets/experiencePage/tutorial-pole.webp"
          />
          <img
            alt="A Qwello charging pole centered against a white background"
            class="PoleImage"
            src="~@/assets/experiencePage/tutorial-pole.png"
          />
        </picture>
      </div>
      <Card
        :align="isMobile ? mobileAlign : 'center'"
        justify="flex-end"
        :left="isMobile ? false : true"
        :col="isMobile ? mobileCol : 1"
        :row="isMobile ? 2 : 1"
        :translateX="isMobile ? '-6vw' : 0"
        :headerText="$t('qwello_station.pole_detail_2.title')"
        >{{ $t('qwello_station.pole_detail_2.text') }}</Card
      >
      <Card
        :align="isMobile ? mobileAlign : 'center'"
        justify="flex-end"
        :left="isMobile ? false : true"
        :col="isMobile ? mobileCol : 1"
        :row="isMobile ? 4 : 2"
        :translateX="isMobile ? '-4vw' : 0"
        :headerText="$t('qwello_station.pole_detail_4.title')"
        >{{ $t('qwello_station.pole_detail_4.text') }}</Card
      >
      <Card
        :align="isMobile ? mobileAlign : 'center'"
        justify="flex-end"
        :left="isMobile ? false : true"
        :col="isMobile ? mobileCol : 1"
        :row="isMobile ? 6 : 3"
        :translateX="isMobile ? '-4vw' : 0"
        :headerText="$t('qwello_station.pole_detail_6.title')"
        >{{ $t('qwello_station.pole_detail_6.text') }}</Card
      >

      <Card
        align="flex-start"
        :left="false"
        :col="isMobile ? mobileCol : 3"
        row="1"
        :isMobile="isMobile"
        :translateX="isMobile ? '-4vw' : 0"
        :headerText="$t('qwello_station.pole_detail_1.title')"
        >{{ $t('qwello_station.pole_detail_1.text') }}</Card
      >
      <Card
        margin="2em"
        align="flex-start"
        :left="false"
        :col="isMobile ? mobileCol : 3"
        :row="isMobile ? 3 : 2"
        :translateX="isMobile ? '-4vw' : 0"
        :headerText="$t('qwello_station.pole_detail_3.title')"
        >{{ $t('qwello_station.pole_detail_3.text') }}</Card
      >
      <Card
        :align="isMobile ? mobileAlign : 'flex-end'"
        :left="false"
        :col="isMobile ? mobileCol : 3"
        :row="isMobile ? 5 : 2"
        :margin="margin"
        :lineWidth="lineWidth"
        :headerText="$t('qwello_station.pole_detail_5.title')"
        >{{ $t('qwello_station.pole_detail_5.text') }}</Card
      >
    </section>
  </article>
</template>

<script>
import Title from '../Title.vue';
import Card from './Card.vue';
import { Flex } from '../../../layout/flexbox';
import Space from '../../../layout/space';

export default {
  components: {
    Title,
    Space,
    Card,
    Flex,
  },
  data() {
    return {
      isMobile: null,
      mobileCol: '2 / 4',
      mobileAlign: 'flex-start',
      lineWidth: '146px',
      margin: null,
    };
  },
  created() {
    // init state on mount
    this.onResize();
  },

  methods: {
    onResize() {
      // check for mobile screen size
      this.checkForMobile();
      // no margin for ipad pro
      if (window.innerWidth >= 1024 && window.innerWidth < 1400) {
        this.margin = '0em';
      }
      // set margin and line width for other screen sizes
      if (window.innerWidth >= 1400) {
        this.margin = '4em';
        this.lineWidth = '146px';
      } else if (window.innerWidth < 1024) {
        this.margin = '1em';
        this.lineWidth = '40px';
      } else {
        this.lineWidth = '60px';
      }
    },
    checkForMobile() {
      if (window.innerWidth < 768 && !this.isMobile) {
        this.isMobile = true;
      } else if (window.innerWidth >= 768 && this.isMobile) {
        this.isMobile = false;
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};
</script>

<style scoped>
article {
  margin-top: 80px;
}
.TutorialGrid {
  display: grid;
  height: max-content;
  grid-template-columns: 1.9fr 1fr 2fr;
  grid-template-rows: 60px 140px 80px 97px 150px 160px;
}
.PoleImageWrapper {
  height: 700px;
  grid-column: 1 / 3;
  grid-row: 1 / -1;
  margin-left: -2em;
}
.PoleImage {
  display: block;
  max-width: 100%;
  max-height: 100%;
}
@media (min-width: 345px) {
  .TutorialGrid {
    grid-template-columns: 1.7fr 1fr 2fr;
  }
}

@media (min-width: 365px) {
  .TutorialGrid {
    grid-template-columns: 1.6fr 1fr 2fr;
  }
}
@media (min-width: 385px) {
  .TutorialGrid {
    grid-template-columns: 1.5fr 1fr 2fr;
  }
}
@media (min-width: 400px) {
  .TutorialGrid {
    grid-template-columns: 1.8fr 1fr 2fr;
  }
  .PoleImageWrapper {
    margin-left: -2em;
  }
}
/* Media Queries */

@media (min-width: 768px) {
  article {
    margin-top: 45px;
  }
  .TutorialGrid {
    grid-template-columns: 1fr auto 1fr;
    grid-template-rows: 1.1fr minmax(auto, 1.5fr) 1.2fr;
    grid-auto-rows: auto;
  }
  .PoleImageWrapper {
    height: 720px;
    grid-column: 2;
    grid-row: 1 / -1;
    justify-self: center;
    margin-left: 0;
  }
}

@media (min-width: 1024px) {
  article {
    margin-top: 140px;
  }
  .TutorialGrid {
    grid-template-columns: 1fr auto 1fr;
    grid-template-rows: 1fr 1.3fr 1.25fr;
    grid-auto-rows: auto;
  }
  .PoleImageWrapper {
    height: 1209px;
    grid-column: 2;
    grid-row: 1 / -1;
    justify-self: center;
  }
}

@media (min-width: 1200px) {
  .TutorialGrid {
    grid-template-columns: 1fr auto 1fr;
    grid-template-rows: 1fr 1.3fr 1.25fr;
    grid-auto-rows: auto;
  }
  .PoleImageWrapper {
    height: 1209px;
    grid-column: 2;
    grid-row: 1 / -1;
    justify-self: center;
  }
}

@media (min-width: 1400px) {
  article {
    margin-top: 180px;
  }
  .TutorialGrid {
    grid-template-columns: 1fr auto 1fr;
    grid-template-rows: 1fr 1.5fr 1fr;
    grid-auto-rows: auto;
  }
  .PoleImageWrapper {
    height: 1209px;
    grid-column: 2;
    grid-row: 1 / -1;
    justify-self: center;
  }
}
</style>
